<div class="request-field-filters" *ngIf="!isLoadingLabels">
	<div class="header-wrap">
		<div class="tab selected" [title]="labels.lbl_geral_selecao_filtros_ocultara_campos_correspondentes">
			{{ labels.lbl_filtros_disponiveis }} <fa-icon [icon]="icons.faInfoCircle"></fa-icon>
		</div>
	</div>
	<div class="body-wrap">
		<ng-container *ngIf="!isLoadingFilters">
			<div *ngIf="this.requestFilters.length > 0">
				<cpi-generic-form-gen [setGenericForm]="filterOptionsEnduser" [columns]="1" [labels]="labels" [columns]="2">
				</cpi-generic-form-gen>
			</div>

			<div *ngIf="this.requestFilters.length > 0">
				<cpi-generic-form-gen [setGenericForm]="filterOptionsAnalyst" [columns]="1" [labels]="labels" [columns]="2">
				</cpi-generic-form-gen>
			</div>

			<div class="button-container">
				<div class="button" [ngClass]="{ disabled: isUpdating || isReseting }" (click)="deleteFilter()">
					{{ labels.lbl_reiniciar_filtros }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isReseting"></cpi-dot-bounce-loading-effect>
				</div>
				<div class="button" [ngClass]="{ disabled: isUpdating || isReseting }" (click)="saveFilter()">
					{{ labels.lbl_geral_salvar }}
					<cpi-dot-bounce-loading-effect [color]="'var(--const-white)'" *ngIf="isUpdating"></cpi-dot-bounce-loading-effect>
				</div>
			</div>
		</ng-container>

		<cpi-dot-bounce-loading-effect *ngIf="isLoadingFilters" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
	</div>
</div>

<cpi-dot-bounce-loading-effect *ngIf="isLoadingLabels" [color]="'var(--primary-color-1)'"></cpi-dot-bounce-loading-effect>
